import type { InboxSortOption } from './types';

/**
 * Alvo B round2 — wiring cap→default de ordenação, extraído como helper puro
 * (mesmo padrão do sort hint T B11: testável sem montar InboxPage).
 *
 * Com a capability `inbox-recency-default`: o pouso ordena por «Mais
 * recentes». Sem ela: default histórico «Urgência (Conflict+SLA)»,
 * byte-idêntico. `?sort=` explícito na URL vence sempre (useInboxFilters).
 */
export function resolveInboxDefaultSort(hasRecencyCap: boolean): InboxSortOption {
  return hasRecencyCap ? 'recency' : 'urgency';
}

/**
 * Contagem honesta do pagehead: «X de Y carregadas · » quando o total da aba
 * (agregado do servidor) existe e excede o que está na tela. Aba sem agregado
 * (team-queue) ou total ≤ exibido: null (texto histórico, sem prefixo).
 */
export function buildLoadedPrefix(loaded: number, tabTotal: number | undefined): string | null {
  if (tabTotal === undefined || tabTotal <= loaded) return null;
  return `${loaded} de ${tabTotal} carregadas · `;
}

/**
 * Escopo dos contadores do pagehead (A-45, noturna 04/Set/2026). Quando a lista
 * está truncada («20 de 4051 carregadas»), «20 ativas · 0 em atendimento · 20 em
 * espera» descreve a PÁGINA, não o tenant — e o operador lia como total. O rótulo
 * torna o escopo explícito; sem truncagem a lista é o todo e o rótulo é vazio.
 */
export function buildPageScopeLabel(loaded: number, tabTotal: number | undefined): string {
  return buildLoadedPrefix(loaded, tabTotal) === null ? '' : 'nesta página: ';
}
